import { nativeStyles } from '../native/styles/native'
import WebModel from '../models/WebModel'

const defaultSidebarWidth = 1100

export const getBaseStyles = ({
  adhesion_light,
  custom_css,
  recipe_float,
  bidders,
  sidebar_minimum_width
}: WebModel) =>
  `
  .mv-empty-wrapper {	
    margin: 0 !important;	
    height: 0px !important;	
    min-height: unset !important;	
  } 
  .adunitwrapper {
    overflow: hidden;
    position: relative;
    /* Typical height + padding for adunitlabels */
    height: 264px;
    /* Typical Width */
    width: 300px;
    /* try transition in separate a/b test */
    /* transition: all 0.5s; */
  }

  .adunitlabel {
    display: none;
  }

  body .adunitwrapper[style*='display: block']>.adunit:before {
    content: "Loading Ad...";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    -webkit-align-content: center;
    align-content: center;
    justify-content: center;
    font-size: 14px;
    color: #999;
    display: -webkit-box;
    -webkit-box-pack: center;
    -webkit-box-align: center;
    box-sizing: border-box;
  }

  [data-slot] {
    height: 264px;
  }

  [data-hint-slot-inserted="true"] {
    height: revert;
  }

  .mv-outstream-container + .adunit:before { 
    display: none!important;
  }

  body .adunitwrapper[style*='display: block']>.adunit {
    position: relative;
  }

  body .adunitwrapper[style*='display: block']>.adunit>div {
    position: relative;
  }

  .adhesion_wrapper {
    display: none;
    max-height: 90px!important;
  }

  .mv-native-size {
    display: flex;
    justify-content: center;
    padding-bottom: 14px;
    height: initial;
  }

  .mv-native-size div[id^='google_ads'] {
    min-height: 100%!important;
    height: 100%!important;
    width: 100%!important;
  }

  .mv-dynamic-size div[id^='google_ads'] {
    height: initial!important;
    width: initial!important;
  }

  .adunitlabel {
    position: absolute;
    width: inherit;
    bottom: 0px;
    color: #a5a5a5;
    font-size : 12px !important;
    line-height : 12px !important;
    text-align : left;
    margin: 0 auto;
    min-width: 160px;
  }

  .mv-outstream-container {
    position: absolute;
  }
  
  .mv-outstream-mute {
    position: absolute;
    top: 5px;
    left: 5px;
    width: 30px;
    height: 30px;
    z-index: 999;
  }

  .mv-mute-button{
    pointer-events: none;
  }

  .mv-mute-button object {
    width: 32px;
  }

  #arrival_wrapper {
    margin: 10px auto 20px auto!important;
  }

  .mv-arrival-continue-button {
    margin: 0 auto;
    display: block;
    width: 300px;
    text-align: center;
    border-top: 1px solid #efefef;
    padding: 15px 0px;  
  }

  body.adhesion {
    padding-bottom: 90px!important;
  }

  .mediavine img {
    margin : 0 !important;
    padding : 0 !important;
    border : 0 !important;
    box-shadow: none !important;
  }

  .adunitlabel a {
    color: #a5a5a5;
    text-decoration : none;
  }
  .adunitlabel .mv-ad-report-button {
    float : right;
    cursor: pointer;
    position: relative;
    border: none;
    width: 100%;
    top: 0;
    background: none;
    padding: 0;
    outline: none;
    line-height: 12px;
  }

  .adunitlabel .mv-ad-report-button:after {
    content: "Report this ad";
    display: block;
    top: 0;
    right: 0;
    position: absolute;
    height: 16px;
    font-size: 12px;
    color: #a5a5a5;
    text-decoration: none;
    text-transform: none;
    text-align: right;
    letter-spacing:0;
  }

  .sidebar_btf_wrapper {
    margin : 0 auto 0 auto;
    width : 300px;
  }

  .recipe_mobile_wrapper,
  .content_mobile_wrapper,
  .comments_mobile_wrapper {
    margin-bottom : 10px;
  }

  [data-recipe-ads-inserted] .recipe_btf_wrapper,
  [data-recipe-ads-inserted] .recipe_mobile_wrapper {
    margin: 0 auto;
  }

  .wprm-recipe-ingredients-container .recipe_btf_wrapper{
    float: right;
  }

  .tasty-recipes-ingredients .recipe_btf_wrapper{
    float: right;
  }

  @media (max-width: ${(sidebar_minimum_width || defaultSidebarWidth) - 1}px) {
    #sidebar_btf_sticky_wrapper, .sidebar_btf_wrapper {
      display : none !important;
    }
  }


  .mv-create-target { 
    max-width: 300px !important;
  }

  .adunit a,
  .adunit object,
  .adunit embed,
  .adunit img,
  .adunit div,
  .adunit iframe {
    margin: 0 auto !important;
    text-align: center;
  }

  .content_btf_wrapper.native,
  .content_mobile_wrapper.native {
    max-width : 600px;
  }

  .content_float_right {
    margin : 0 0 10px 20px;
    float : right;
  }

  .content_mobile_wrapper,
  .recipe_mobile_wrapper,
  .comments_mobile_wrapper,
  .comments_btf_wrapper,
  .comments_mobile_wrapper,
  .content_btf_wrapper,
  .feed_mobile_wrapper,
  .feed_btf_wrapper {
    margin : 10px auto 20px auto;
    text-align : center;
  }

  .leaderboard_atf_wrapper,
  .sidebar_atf_wrapper,
  .leaderboard_btf_wrapper {
    margin : 0px auto 20px auto;
    text-align : center;
  }
  .leaderboard_btf_wrapper {
    margin-top : 20px;
  }

  @media (max-width : 727px) {
    .leaderboard_atf_wrapper {
      display : none !important;
    }
  }

  .adhesion_wrapper.adhesion_container {
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    text-align: center;
    width: 100% !important;
    z-index: 2147483646;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    ${
      adhesion_light
        ? `background-color: rgba(250, 250, 250, 0.9);`
        : `background-color: rgba(0, 0, 0, 0.9);`
    }
  }

  .adhesion_wrapper div {
    margin: 0px;
  }

  .gumgumAdhesion .adhesion_wrapper {
    visibility: hidden;
  }

  .adhesion_wrapper .adhesion_buttons {
    height: 48px;
    width: 48px;
    display: block;
   }

  .adhesion_wrapper .mv_close_button {
    width: 48px;
    height: 48px;
    display: block;
    position: relative;
    cursor: pointer; 
  }

  .adhesion_wrapper .mv_unbutton {
    padding: unset;
    border: unset;
    background-color: transparent;
  }

  .adhesion_wrapper .mv_close_button object {
    width: 24px;
    height: 24px;
    pointer-events: none;
    /* Position it 50% from the top-left corner. */
    position: absolute;
    top: 50%;
    left: 50%;
    /* Then move it back half its width and height for perfect centering. */
    transform: translate(-50%, -50%);
  }


  /*Push Logo Up*/
  @media (max-width: 350px) {
    .adhesion_wrapper .adhesion_buttons {
      display: none;
    }
  }

  @media (min-width: 728px) and (max-width: 840px) {
    
  }

  @media (max-width: 727px) {
    body.adhesion {
      padding-bottom : 50px;
    }
    .adhesion_wrapper.adhesion_container {
      justify-content: center;
    }

    /* Provides centered padding for Mediavine logo and Report Button */
    .mv-native-size .adunitlabel {
      max-width: calc(100vw - 15px) !important;
    }
  }

  @media (min-width: 728px) {
    body.adhesion {
      padding-bottom : 90px;
    }
  }

  ${
    // Ensures recipe_float only applies to first
    // recipe slot via styling #recipe_btf_wrapper
    recipe_float
      ? `
  #recipe_btf_wrapper {
    float : right;
    margin : 0 0 20px 20px !important;
  }
  `
      : `
  .recipe_btf_wrapper {
    width : 300px;
    margin : 20px 0 20px 0px !important;
  }`
  }

  @media print {
    .adunit,
    .adunitlabel,
    .adunitwrapper,
    .adhesion_wrapper {
      display : none !important;
    }
  }

  #sovrn_beacon {
    position: absolute
  }

  ${
    bidders.find((bidder) => bidder.name === 'triplelift')
      ? `
   .triplelift {
      margin-bottom : 5px !important;
    }

    .triplelift .entry-title {
      background : none !important;
      font-size : 18px;
      line-height : 22px;
      clear : none !important;
    }
    .triplelift .entry-content {
      clear : none !important;
      background : none !important;
    }
    .triplelift .entry-meta {
      display : block !important;
      background : none !important;
      clear : none !important;
      border : none !important;
      float : none !important;
    }
    .triplelift .entry-title a {
      line-height: inherit !important;
      float: none !important;
      width: auto !important;
      height: auto !important;
      background: none !important;
      color: inherit !important;
      font-size: inherit !important;
      line-height: inherit !important;
      margin: 0 !important;
      padding: 0 !important;
    }
    `
      : ``
  }

  ${nativeStyles}
  
  ${custom_css || ''}
`
